function initInfoModal() {

    const documentBody = document.querySelector('body'); 

    const colletionBtns = document.querySelectorAll('.colletion-btn');

    function openInfoModal(html){


        appendModalHtml(html);

        const infoModalHolder   = document.querySelector('#info-holder');
        ///const infoModalInner    = document.querySelector('#info-content-holder');
        const closeTrigger      = infoModalHolder.querySelector('.btn-circle-close');
        const flexContainer   = document.querySelector('#flex-container');
        

        //gsap.set(infoModalInner, {x: -50,transformOrigin: '0% 0%'});

        document.body.classList.add('overflow-hidden');

        const infoSwiper = document.querySelector('#info-holder .swiper');

        if (infoSwiper) {


            const swiper = new Swiper(infoSwiper, {
                pagination: {
                  el: ".swiper-pagination",
                },
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
            });


        }

        const imHolder = document.querySelector('#info-holder .img-holder');

        window.addEventListener("resize", debounce( resizeContent, 150 ));

        // Function with stuff to execute
        function resizeContent() {
            // Do loads of stuff once window has resized
            

            if (isLandscape()) {
                console.log('landscape');
                flexContainer.classList.add('flex-row');
                flexContainer.classList.remove('flex-column');
                fixImageHolderWidth(imHolder);
            } else {
                console.log('portrait');
                flexContainer.classList.remove('flex-row');
                flexContainer.classList.add('flex-column');
                fixImageHolderWidth(imHolder);
            }
        }


        setTimeout(function(){

            resizeContent();


        },100)



        gsap.to(infoModalHolder, {ease: Power1.easeOut, x: 0,  duration: 0.6,  delay: 0.2, onComplete(){

        }});

        setTimeout(function(){ 

            //gsap.to(infoModalInner, {ease: Power1.easeIn, x: 0,  duration: 0.3,  onComplete(){ }});

        },280);

        closeTrigger.addEventListener('click', function(){

            closeInfoModal();
        })

    }

    function closeInfoModal(){

        const infoModalHolder   = document.querySelector('#info-holder');
        const infoModalInner    = document.querySelector('#info-content-holder');


        document.body.classList.remove('overflow-hidden');

        gsap.to(infoModalInner, {ease: Power1.easeIn, x: -50,  duration: 0.3, onComplete(){}});
        setTimeout(function(){ 
            gsap.to(infoModalHolder, {ease: Power1.easeOut, x: '-100%',  duration: 0.6, onComplete(){

                infoModalHolder.remove();
            }});
        },280);

    }

    function loadModal(post_id) {

        loading.show(documentBody,'neg','fixed');

        var request = new XMLHttpRequest();
        //cursor.setAjaxState();
        request.open('POST', ajaxurl, true);
        request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded;');
        request.onload = function () {
            if (this.status >= 200 && this.status < 400) {
                // If successful
                openInfoModal(this.responseText);
                loading.hide();
            } else {
                // If fail
                openInfoModal('<h3>Es ist ein Fehler aufgetreten</h3>');
                loading.hide();
            } 
        };
        request.onerror = function() {
            openInfoModal('<h3>Es ist ein Fehler aufgetreten</h3>');
            loading.hide();
        };
        request.send('action=load_info_modal&post_id=' + post_id);
    }



    function appendModalHtml(content) {

        const html = `<div class="info-holder bg-dark text-light" id="info-holder">
                        <button class="btn-circle-close"><span class="visually-hidden-focusable">schliessen</span></button>
                        <div class="overflow-scroll h-100 ">
                            ${content}
                        </div>
                    </div>`;

        appendHtml(document.querySelector('body'), html);

        //return html;
    }

    function fixImageHolderWidth(container) {

        const height = container.offsetHeight

        container.style.width = height+'px';

    }

    colletionBtns.forEach(colletionBtn => {

        colletionBtn.addEventListener('click', function(e){

            e.preventDefault;

            const postId = this.dataset.postId;

            loadModal(postId);
        });
    });


    function isLandscape() {
        return (window.innerWidth > window.innerHeight);
      }


    // Debounce
    function debounce(func, time){
        var time = time || 200; // 100 by default if no param
        var timer;
        return function(event){
            if(timer) clearTimeout(timer);
            timer = setTimeout(func, time, event);
        };
    }

    


    return {

       // openMenu:  openMenu,
       // closeMenu: closeMenu
    }
}
